import Metacarattere from 'metacarattere';

function addQueryParams(url, queryParams) {
  if (Object.keys(queryParams).length === 0) {
    return url;
  }

  return `${url}?${new URLSearchParams(queryParams).toString()}`;
}

export default function buildParamsUrl(baseUrl, params = {}) {
  if (!/[:*]/.test(baseUrl)) {
    return addQueryParams(baseUrl, params);
  }

  const base = new Metacarattere(baseUrl);
  let builtUrl = base.build(params);
  const usedTerms = base.getPlaceholders();

  if (!builtUrl || builtUrl.indexOf(':') !== -1) {
    throw new Error(`Incorrect parameters for ${baseUrl}: ${JSON.stringify(params)}`);
  }

  builtUrl = builtUrl.replace(/\*([a-z0-9_]+)/, (all, term) => {
    if (!params[term]) {
      throw new Error(`Incorrect parameters for ${baseUrl}: ${JSON.stringify(params)}`);
    }

    usedTerms.push(term);

    return params[term];
  });

  const queryParams = {};
  Object.keys(params).forEach((key) => {
    if (usedTerms.indexOf(key) === -1) {
      queryParams[key] = params[key];
    }
  });

  return addQueryParams(builtUrl, queryParams);
}
